import {useEffect, useState} from 'react';
import './SignUpThankYou.css';

export const SignUpThankYou = () => {
  const [thankYouDate, setThankYouDate] = useState('');

  useEffect(() => {
    const dt = new Date();
    let delta = 0;

    if (dt.getDay() <= 1) {
      // monday
      delta = 2-dt.getDay();
    } else if ((dt.getDay() === 2) && (dt.getHours() < 7)) {
      delta = 0;    
    } else {
      delta = 9-dt.getDay();
    }
    const nextDate = new Date(dt);
    nextDate.setDate(nextDate.getDate() + delta);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };

    setThankYouDate(nextDate.toLocaleDateString("en-US", options));
  }, []);

  return (
    <div className="thankYouMain" >
      <div className="thankYouContent" >
        <div className="thankYouLogo" >
           <img alt="Drops" className="landingBarImg" src="/images/landing/Illustrations/Various_Illustrations/DROPS_LOGO_10_21.svg" />
        </div>
        <div className="thankYouTitle">
        <h1>Your information has been saved securely</h1>
        </div>
        <div className="thankYouExpect">
        <p>You will receive your first coffee offer text from us on:</p>
        </div>
        <div className="thankYouDate">
        <p id="thankYouDate">{thankYouDate}</p>
        </div>
        <div className="thankYouSubtext">
        It is free to receive our texts every week. You will only be charged if you reply and place an order.
        </div>
      </div>
    </div>

  );
}

